/**
 * Variables defined in this file are intended to be used throughout various
 * components of the application.
 */

export const LocalStore = window.localStorage

export class LocalStoreKeys {
  static get AppId() { return `${LocalStoreKeys.Base}.app_id` }
  static get Base() { return 'co.scibeam.candela' }
  static get DarkTheme() { return `${LocalStoreKeys.Base}.dark_theme` }
  static get UserNamespace() { return `${LocalStoreKeys.Base}.ns` }
}

export const ControlTypes = [
  'button',
  'button-group',
  'list',
  'progress',
  'select',
  'slider',
  'text-input',
  'toggle'
]

export class ReqOps {
  static get APIKey() { return 'req-ops-api-key' }
  static get Apps() { return 'req-op-apps' }
  static get AppLayout() { return 'req-op-app-layout' }
  static get AppSettings() { return 'req-op-app-settings' }
  static get Connect() { return 'req-op-connect' }
  static get CreateApp() { return 'req-op-app-create' }
  static get DeleteAccount() { return 'req-op-delete-account' }
  static get Login() { return 'req-op-login' }
  static get SaveApp() { return 'req-op-app-save' }
}

export class ReqState {
  static get Request() { return 'req-state-request' }
  static get Complete() { return 'req-state-complete' }
  static get Error() { return 'req-state-error' }
  static get None() { return 'req-state-none' }
}
